import { GNS } from './GNS.js';

/**
 * GNS.EventDispatcher
 * 
 * Observer パターンの実装
 * イベントの登録・削除・発行を管理
 * 
 * 主要メソッド:
 * - addEventListener(type, callback): イベントリスナー登録
 * - removeEventListener(type, callback): イベントリスナー削除
 * - dispatchEvent(event): イベント発行
 * - hasEventListener(type, callback): リスナー存在チェック
 */
GNS.EventDispatcher = function (a) {
    var b = a.create();

    /**
     * init() - 初期化
     * リスナーオブジェクトを初期化
     */
    return b.init = function () {
        this.listeners = {}
    },

        /**
         * dispatchEvent(event) - イベント発行
         * 登録されたすべてのリスナーにイベントを通知
         */
        b.dispatchEvent = function (a) {
            if (a && a.type) {
                var b = a.type;
                if (this.listeners[b]) {
                    a.target = this;
                    for (var c = this.listeners[b], d = c.length, e = d - 1; e >= 0; e--) c[e](a)
                }
            }
        }, b.addEventListener = function (a, b) {
            if ("string" == typeof a && "function" == typeof b) {
                this.listeners[a] || (this.listeners[a] = []);
                for (var c = this.listeners[a], d = c.length, e = 0; d > e; ++e)
                    if (c[e] == b) return;
                this.listeners[a][d] = b
            }
        }, b.removeEventListener = function (a, b) {
            if ("string" == typeof a && "function" == typeof b && this.listeners[a]) {
                for (var c = this.listeners[a], d = c.length, e = 0; d > e && c[e] != b; ++e);
                e != d && this.listeners[a].splice(e, 1)
            }
        }, b.removeAllEventListener = function () {
            for (var a in this._listeners) this.listeners[a].length = 0, delete this.listeners[a];
            this.listeners = {}
        }, b.hasEventListener = function (a, b) {
            if ("string" != typeof a) return !1;
            if ("function" != typeof b) return !1;
            if (!this.listeners[a]) return !1;
            for (var c = this.listeners[a], d = c.length, e = 0; d > e; ++e)
                if (c[e] == b) return !0;
            return !1
        }, b._self
}(GNS);
